
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m24.183 5.51.915 2.056 4.721-.46-3.5 3.2.914 2.056a.25.25 0 0 1-.126.33l-.914.407a.251.251 0 0 1-.33-.127l-.305-.685-11.816 5.26 4.005 4.779a.75.75 0 0 1-1.15.963l-3.047-3.636-.565 4.97-.007.063-.012.062a1.753 1.753 0 0 1-1.005 1.255l-1.084.483a1.75 1.75 0 0 1-2.428-1.26l-1.417-7.154-1.802.803a1.001 1.001 0 0 1-1.32-.507L2.18 14.485l1.37-.61 1.526 3.426 1.657-.738-.07-.353-.306-1.546a1.741 1.741 0 0 1 1.005-1.939l1.763-.784a1.747 1.747 0 0 1 1.845.273l12.146-5.408-.305-.686a.25.25 0 0 1 .127-.33l.914-.406a.25.25 0 0 1 .33.126ZM10.267 25.115l1.084-.482a.25.25 0 0 0 .144-.18l.706-6.22-2.135-4.795a.251.251 0 0 0-.33-.127l-1.763.785a.25.25 0 0 0-.144.277L9.92 24.936a.25.25 0 0 0 .347.18Zm13.46-16.939-11.986 5.337 1.22 2.74 11.987-5.336-1.22-2.741Zm-10.539 5.513 8.332-3.71a.25.25 0 0 1 .33.127l.407.914a.25.25 0 0 1-.127.33l-8.332 3.71a.25.25 0 0 1-.33-.127l-.406-.913a.25.25 0 0 1 .126-.33Z"}})])
          )
        }
      }
    